import FeatherIcon from "feather-icons-react";
import React, { Component } from "react";

class FeatureBox extends Component {
  render() {
    return (
      <React.Fragment>
        <div className="avatar-md mb-4">
          <span className="avatar-title rounded-circle bg-soft-primary">
            <i>
              <FeatherIcon
                icon={this.props.icon}
                className="icon-dual-primary"
              />
            </i>
          </span>
        </div>
        <h5>{this.props.title}</h5>
        <p className="mb-4">{this.props.desc}</p>
      </React.Fragment>
    );
  }
}

export default FeatureBox;
